export const CUSTOMERS_LIST_PATH = 'list'
export const CUSTOMER_PROFILE_PATH = '/customers/customer-profile'
export const CREATE_NEW_CUSTOMER_PATH = '/customers/create-new-customer'
export const CUSTOMER_SPEC_SUB_PATH = 'customer-spec'
export const CUSTOMER_ID_SUB_PATH = 'customer-id'

export const CUSTOMER_QUOTES_KEY = 'customerQuotesKey'
export const CUSTOMER_SPECS_KEY = 'customersSpecsKey'
export const CUSTOMERS_KEY = 'customersKey'
export const SPEC_DETAILS_KEY = 'specDetailsKey'

export const EQUIPMENT_TYPE = {
  ATTACHMENT: 'Attachment',
  MACHINE: 'Machine'
} as const

export type EquipmentTypeKey = keyof typeof EQUIPMENT_TYPE
export type EquipmentTypeValue = (typeof EQUIPMENT_TYPE)[EquipmentTypeKey]

export const GENERAL_MACHINE_TYPES = {
  ATTACHMENT: 'Attachment',
  MACHINE: 'Machine'
}

export const MACHINE_TYPE = {
  ATTACHMENT: 'attachment',
  EQUIPMENT: 'equipment'
}

export const WARRANTY_TYPES = {
  EXTENDED: 'Extended',
  STANDARD: 'Standard'
}

export const SERVICE_CONTRACT_TYPES = {
  ARDUOUS: 'Arduous',
  NONE: 'None',
  STANDARD: 'Standard'
}

export const FACTORY_OPTIONS_TYPES = {
  FACTORY_FIT: 'Factory fit',
  STANDARD: 'Standard'
}

export const RULE_ACTIONS = {
  REPLACE: 'replace',
  REQUIRE: 'require',
  SUGGEST: 'suggest'
}

export enum applyToEqSteps {
  CONFLICTS = 'conflicts',
  SELECT_EQ = 'selectEquipment'
}

export enum addToQuoteSteps {
  EQ_OVERVIEW = 'equipmentsOverview',
  EXISTING_QUOTE = 'addToExistingQuote',
  NEW_QUOTE = 'addToNewQuote'
}
